import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie";

// Import modules
import __rules from "./__helpers/__rules";
import __global from "./__helpers/__global";
import __modal from "./__helpers/__modal";

//Import Api Stores
import logoutDialog from "./dialog/logout";
import authentication from "./authentication";
import commissionstatistics from "./commissionstatistics";
import dashboard from "./dashboard";
import profile from "./profile";
import tradingHistory from "./tradingHistory";
import accounttypes from "./accounttypes";
import transactionReports from "./transactionReports";
import faq from "./faq";
import accountsummary from "./accountssummary";
import clienttree from "./clienttree";
import partnerprofile from "./partnerprofile";
import paymentmethods from "./paymentmethods";
import tradingaccounts from "./tradingaccounts";
import markettingtools from "./markettingtools";
import commissionstates from "./commissionstates";
import droneview from "./droneview";
import clientlevelearning from "./clientlevelearning";
import notifications from "./notifications";
import acctypes from "./acctypes";
import company from "./company";
import publicinfo from "./publicinfo";
import agreements from "./agreements";
import panelSwitcher from "./panelSwitcher";
import tradeMaster from "./tradeMaster";

Vue.use(Vuex);

const state = {
  baseUrl: "/",
};

const getters = {};
const mutations = {};
const actions = {};

const plugins = [
  createPersistedState({
    key: "partner_panel",
    paths: ["authentication.token"],
    storage: {
      getItem: (key) => Cookies.get(key),
      setItem: (key, value) => {
        try {
          const data = JSON.parse(value);
          if (data?.authentication?.token) {
            Cookies.set(key, value, {
              expires: 1,
              domain: process.env.VUE_APP_DOMAIN_URL || undefined, // undefined for localhost
              secure: process.env.VUE_APP_SECURE === 'true', // Convert string to boolean
              sameSite: process.env.VUE_APP_SAME_SITE === 'None' ? 'None' : 'Lax' // Case-sensitive
            });
          } else {
            Cookies.remove(key, {
              domain: process.env.VUE_APP_DOMAIN_URL || undefined, // undefined for localhost
              secure: process.env.VUE_APP_SECURE === 'true', // Convert string to boolean
              sameSite: process.env.VUE_APP_SAME_SITE === 'None' ? 'None' : 'Lax' // Case-sensitive
            });
          }
        } catch (e) {
          console.error("Failed to persist state", e);
          Cookies.remove(key, {
            domain: process.env.VUE_APP_DOMAIN_URL || undefined, // undefined for localhost
            secure: process.env.VUE_APP_SECURE === 'true', // Convert string to boolean
            sameSite: process.env.VUE_APP_SAME_SITE === 'None' ? 'None' : 'Lax' // Case-sensitive
          });
        }
      },
      removeItem: (key) => Cookies.remove(key, {
        domain: process.env.VUE_APP_DOMAIN_URL || undefined, // undefined for localhost
        secure: process.env.VUE_APP_SECURE === 'true', // Convert string to boolean
        sameSite: process.env.VUE_APP_SAME_SITE === 'None' ? 'None' : 'Lax' // Case-sensitive
      }),
    },
  }),
];

export default new Vuex.Store({
  strict: true,
  state,
  getters,
  mutations,
  actions,
  modules: {
    __global,
    __rules,
    __modal,
    // components start
    company,
    logoutDialog,
    authentication,
    commissionstatistics,
    dashboard,
    profile,
    tradingHistory,
    accounttypes,
    transactionReports,
    faq,
    agreements,
    accountsummary,
    clienttree,
    partnerprofile,
    paymentmethods,
    tradingaccounts,
    markettingtools,
    commissionstates,
    droneview,
    clientlevelearning,
    notifications,
    acctypes,
    publicinfo,
    panelSwitcher,
    tradeMaster,
    accountsummary
  },
  plugins,
});
